import type { Dispatch } from '@reduxjs/toolkit';
import { FlowTypes } from 'store/constants';
import type { UIPaymentGroups, UIPayoutGroups } from 'store/formatters';

import { setAmount } from '../../store/slices/global';
import { isDepositFlowType } from '../../utils';

interface StoreAmountProps {
  storedAmount: string;
  amountTouched: boolean;
  dispatch: Dispatch;
  m: UIPaymentGroups | UIPayoutGroups;
  userBalance?: number;
  flowType?: FlowTypes;
  isInCarousel?: boolean;
}

// method grouping flow
const storeAmountForCarousel = (
  storedAmount: string,
  m: UIPaymentGroups | UIPayoutGroups,
  maxValue: number | undefined | null,
  dispatch: Dispatch,
) => {
  const storedAmountAsNumber = Number(storedAmount);
  if (!storedAmount || (m.limits?.min && storedAmountAsNumber < m.limits.min)) {
    dispatch(setAmount(`${m.limits?.min}` || ''));
    return;
  }
  if (maxValue && storedAmountAsNumber > maxValue) {
    dispatch(setAmount(`${maxValue}`));
  }
};

export const storeAmount = (props: StoreAmountProps) => {
  const { storedAmount, amountTouched, dispatch, m, userBalance = 0, flowType, isInCarousel = false } = props;

  const isDeposit = isDepositFlowType(flowType ?? FlowTypes.deposit);
  const withdrawalMax = m.limits.max && m.limits.max <= userBalance ? m.limits.max : userBalance;
  const maxValue = isDeposit ? m.limits.max : withdrawalMax;
  const storedAmountAsNumber = Number(storedAmount);

  if (isInCarousel) {
    storeAmountForCarousel(storedAmount, m, maxValue, dispatch);
    return;
  }

  if (!storedAmount || !amountTouched) {
    dispatch(setAmount(`${m.limits?.min}` || ''));
  }

  if (
    storedAmountAsNumber &&
    m.limits &&
    ((m.limits.min && storedAmountAsNumber < m.limits.min) || (maxValue && storedAmountAsNumber > maxValue))
  ) {
    const adjustedAmount = maxValue && storedAmountAsNumber > maxValue ? `${maxValue}` : `${m.limits.min}`;
    dispatch(setAmount(adjustedAmount));
  }
};
